<template>
	<div class="reporting-window features"> 
        <div class="row">
            <div class="col">
                <ul class="list-group my-list">
                    <li class="list-group-item text-left" v-for="msg of firstBoxMessages" :key="msg.id">
                         <span class="msg-time"> {{ formatTime(msg.timestamp) }} </span> {{ msg.text }}
                    </li>
                </ul>
            </div>
        </div>

        <div class="row mt-2" v-if="userName === 'radek'">
            <div class="col col-md-1" v-if="! toggleAdding">
                <button class="btn btn-success" style="width: 100%;" @click="toggleAdding = true"> + </button>
            </div>
            <div  v-else class="col col-md-6 text-left input-group">
                <input class="form-control" v-model="newMessage"/>
                <div class="input-group-append">
                    <button class="btn btn-success btn-outline-success" style="color: black;" type="button" id="button-addon2" @click="saveNewMsg" > ✓ </button>
                    <button class="btn btn-danger btn-outline-danger" style="color: black;" type="button" id="button-addon2" @click="toggleAddingOff"> X </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'

export default {
	name: 'AddUser',
    
    props: {
        firstBoxMessages: Array,
        userName: String,
    },

	data () {
		return {
            newMessage: '',
            toggleAdding: false,
		}
    },

	methods: {
        async saveNewMsg () {
            const saveNew = await AdditionsService.addFeatureMessage(this.newMessage);
            this.$emit('firstBoxMessagesChanged', saveNew.data.msgs)
            this.newMessage = ''
            this.toggleAdding = false
        },

        toggleAddingOff () {
            this.toggleAdding = false
            this.newMessage = ''
        },

        formatTime (timestamp) {
            const newDate = new Date(timestamp)
            const timeFormattedYear = newDate.getUTCFullYear()
            const timeFormattedMonth = newDate.getUTCMonth() + 1
            const timeFormattedDay = newDate.getUTCDate()

            const timeFormattedHour = newDate.getUTCHours()
            const timeFormattedMinute = newDate.getUTCMinutes()
            const timeFormattedSecond = newDate.getUTCSeconds()

            return timeFormattedDay + '.' + timeFormattedMonth + '.' + timeFormattedYear + ' - ' + timeFormattedHour + ':' + timeFormattedMinute + ':' + timeFormattedSecond + ' - '
        }
	},
}
</script>

<style lang="stylus" scoped>
.reporting-window 
    max-height 100vh

.my-list
	max-height 70vh
	min-height 70vh
	overflow-y scroll
	background-color white
	padding 0px

.features-title 
    font-size 24px
    line-height 30px
    text-align center
    border-bottom 1px solid rgb(187, 187, 187)
    padding-top 5px
    padding-bottom 10px
    background-color rgb(31, 142, 246)
    color white

.messages-box 
    overflow-y scroll
    text-align left

.feature-msg 
    border-bottom 1px solid rgb(187, 187, 187)
    margin-top 10px

.msg-time 
    color gray
    font-size 12px

.new-feature-msg 
    height 40px 
    display flex
    flex-direction row
    justify-content left

.new-feature-msg-input 
    height 40px

.new-feature-msg-button 
    height 40px

@media (max-width 1000px) 
    .messages-box  
        text-align center
        width 80%

    .new-feature-msg 
        width 80%

</style>



// WEBPACK FOOTER //
// src/components/info_boxes/FeaturesBox.vue